import React, { useEffect, useState } from 'react';
import GridColumn from '@navi/web-ui/lib/layouts/Grid/GridColumn/GridColumn';
import GridRow from '@navi/web-ui/lib/layouts/Grid/GridRow/GridRow';
import { Drawer } from '@navi/web-ui/lib/primitives';
import styles from '../Enach.module.scss';
import cx from 'classnames';
import { AgTable, Pagination } from '@navi/web-ui/lib/components';
import { GenericObject } from '@cp/src/types/CommonConstans';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { fetchUploadHistory } from '../EnachUploadHistory/enachUploadHistoyDrawerActions';
import { DropDownPosition } from '../../AmeyoUtility/types';

interface UploadHistoryComponentProps {
  showUploadHistoryComponent: boolean;
  setShowUploadHistoryComponent: React.Dispatch<React.SetStateAction<boolean>>;
  data: GenericObject;
  transformRowData: () => Array<GenericObject>;
  columnDefs: any;
  fetchUploadHistoryPolling: (
    pageNo: number,
    pageSize: number,
    documentTypes: string,
    status: string
  ) => void;
  headerText?: string;
  typeOfUpload: string;
  width?: string;
  status: string;
}
const DEFAULT_PAGE_NUMBER = 1;
const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_DRAWER_WIDTH = '810px';

const UploadHistoryComponent = (props: UploadHistoryComponentProps) => {
  const {
    showUploadHistoryComponent,
    setShowUploadHistoryComponent,
    data,
    transformRowData,
    columnDefs,
    fetchUploadHistoryPolling,
    headerText,
    typeOfUpload,
    width = DEFAULT_DRAWER_WIDTH,
    status
  } = props;

  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [rowData, setRowData] = useState<Array<GenericObject>>();
  const [pageNumber, setPageNumber] = useState(DEFAULT_PAGE_NUMBER);
  const pages = useSelector((store: RootState) => store?.enachSlice?.pages);
  const dispatch = useDispatch();

  useEffect(() => {
    setRowData([...transformRowData()]);
    fetchUploadHistory(DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, typeOfUpload, status);
  }, [data]);

  const handleOnPageChange = (pageNumber: number) => {
    setPageNumber(pageNumber);
  };

  const handleOnPageSizeChange = (pageSize: number) => {
    setPageSize(pageSize);
    setPageNumber(1);
  };

  useEffect(() => {
    if (!showUploadHistoryComponent) {
      setPageNumber(DEFAULT_PAGE_NUMBER);
      setPageSize(DEFAULT_PAGE_SIZE);
      return;
    }
    dispatch(fetchUploadHistoryPolling(pageNumber - 1, pageSize, typeOfUpload, status));
  }, [pageNumber, pageSize, showUploadHistoryComponent]);

  return (
    <div>
      <Drawer
        headerText={headerText}
        onClose={() => setShowUploadHistoryComponent(false)}
        open={showUploadHistoryComponent}
        style={{ width: width }}
        contentClasses="overflow-auto"
        usePadding={false}
      >
        <GridRow className="no-gutters">
          <GridColumn md={12} className={cx(styles.Table__table, 'no-gutters')}>
            <AgTable
              defaultColDef={{
                suppressMovable: true,
                wrapText: true,
                autoHeight: true
              }}
              className="uploadHistoryTable"
              rowData={rowData || []}
              columnDefs={columnDefs}
              headerHeight={28}
              rowHeight={48}
              theme={'alpine'}
              sizeColumnsToFit={true}
              getAgRowStyle={() => {
                return { color: 'var(--grayscale-2)' };
              }}
              paginationWrapperClasses={'paginationWrapperClasses'}
              PaginationComponent={
                <Pagination
                  totalCount={pages?.totalElements || 0}
                  onPageChange={handleOnPageChange}
                  currentPage={pageNumber}
                  onPageSizeChange={handleOnPageSizeChange}
                  pageSize={pageSize}
                  pageNumberDropDownPosition={DropDownPosition.TOP}
                />
              }
            />
          </GridColumn>
        </GridRow>
      </Drawer>
    </div>
  );
};

export default UploadHistoryComponent;
